const normalizeSearchText = (value = '') => {
  if (value == null) return '';
  const str = String(value);
  return str.includes(' ')
    ? str.toLowerCase().trim().replace(/\s+/g, ' ')
    : str.toLowerCase().trim();
};

export default normalizeSearchText;
